export const getErrorMessageFromAPI = ({ response }) => {
  if (response?.data?.message) {
    return response?.data?.message;
  } else {
    return response?.data;
  }
};
